import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { debounce } from 'lodash';
import { MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from 'react-router-dom';
import LightBox from '../component/lightbox';
import Loading from '../component/loading';
import Nav from '../component/nav';
import request from '../util/client';

function calcCols() {
  if (window.matchMedia('(max-width: 767px)').matches) {
    return 2;
  } else if (window.matchMedia('(max-width: 991px)').matches) {
    return 3;
  } else if (window.matchMedia('(max-width: 1199px)').matches) {
    return 4;
  } else if (window.matchMedia('(max-width: 1599px)').matches) {
    return 4;
  } else if (window.matchMedia('(max-width: 1919px)').matches) {
    return 5;
  } else if (window.matchMedia('(max-width: 2559px)').matches) {
    return 6;
  } else if (window.matchMedia('(max-width: 3839px)').matches) {
    return 8;
  } else {
    return 10;
  }
}

export default function Home() {
  const [col, setCol] = React.useState(calcCols);
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [random, setRandom] = React.useState((Math.random() * 100000).toFixed(0));
  const params = useParams();
  const lists = React.useRef();
  const lightbox = React.useRef();
  const loading = React.useRef();
  const isLoading = React.useRef(false);
  const isEnd = React.useRef(false);
  const noScroll = React.useRef(false);
  const scrollTop = React.useRef(0);
  const cols = [];
  const navigate = useNavigate();
  const onScroll = (e) => {
    scrollTop.current = lists.current.parentElement.scrollTop;
    if (!noScroll.current && !isLoading.current && !isEnd.current &&
      lists.current.offsetHeight * 0.8 < lists.current.parentElement.scrollTop + lists.current.parentElement.offsetHeight) {
      setPage(page + 1);
    }
  };
  const onClick = React.useRef((data, category, e) => {
    e.stopPropagation();
    e.preventDefault();
    navigate('/app/note/' + (category ? category + '/' : '') + data.noteId);
  });
  const onLike = React.useRef((data, e) => {
    e.stopPropagation();
    e.preventDefault();
    let b = e.target;
    while (b.tagName !== 'BUTTON') {
      b = b.parentElement;
    }
    let type, v = b.querySelector('span');
    if (b.classList.contains('liked')) {
      type = '0';
      b.classList.remove('liked');
      v.innerText = parseInt(v.innerText) - 1;
    } else {
      type = '1';
      b.classList.add('liked');
      v.innerText = parseInt(v.innerText) + 1;
    }
    request('index/note/like', 'POST', { noteId: data.noteId, type });
  });
  const doLoad = () => {
    if (isEnd.current || isLoading.current || !page) {
      return;
    }
    loading.current.show();
    isLoading.current = true;
    let noteChannelId = params.category;
    (noteChannelId ?
      request('index/note/find/channel', 'POST', { pageNo: page, pageRandom: random, noteChannelId: params.category }) :
      request('index/note/find/recommend', 'POST', { pageNo: page, pageRandom: random })).then(response => {
        setData(page === 1 ? response.data.content : [...data, ...response.data.content]);
        loading.current.hide();
        isLoading.current = false;
        noScroll.current = false;
        if (response.data.pageNo >= response.data.totalPages) {
          isEnd.current = true;
        }
      });
  };
  React.useEffect(doLoad, [page]);
  React.useEffect(() => {
    isEnd.current = false;
    noScroll.current = true;
    if (page === 1) {
      doLoad();
    } else {
      setPage(1);
    }
  }, [params.category, random]);
  React.useEffect(() => {
    let width = cols[0].offsetWidth;
    for (const c of cols) {
      c.innerHTML = '';
    }
    for (let item of data) {
      let min = cols[0];
      for (const c of cols) {
        if (min.offsetHeight > c.offsetHeight) {
          min = c;
        }
      }
      let node = window.document.createElement('div');
      node.className = 'card';
      node.addEventListener('click', onClick.current.bind(null, item, params.category));
      let img = window.document.createElement('img');
      img.width = width;
      img.height = item.showUrlHeight * width / item.showUrlWith;
      img.className = 'card-img-top';
      img.onload = function () {
        img.classList.add('loaded');
      };
      img.src = item.showUrl;
      node.appendChild(img);
      let body = window.document.createElement('div');
      body.className = 'card-body';
      node.appendChild(body);
      let title = window.document.createElement('h4');
      title.className = 'title';
      title.title = title.innerText = item.title;
      body.appendChild(title);
      let profile = window.document.createElement('div');
      profile.className = 'profile';
      body.appendChild(profile);
      let avatarContainer = window.document.createElement('span');
      avatarContainer.className = 'avatar';
      profile.appendChild(avatarContainer);
      let avatar = window.document.createElement('img');
      avatar.width = 32;
      avatar.height = 32;
      avatar.src = item.avatarUrl;
      avatarContainer.appendChild(avatar);
      let name = window.document.createElement('span');
      name.className = 'nickname';
      name.title = name.innerText = item.nickname;
      profile.appendChild(name);
      let like = window.document.createElement('button');
      like.className = 'btn btn-link btn-like' + (parseInt(item.isLikeNote) ? ' liked' : '');
      like.addEventListener('click', onLike.current.bind(null, item));
      createRoot(like).render((
        <>
          <FontAwesomeIcon icon={faThumbsUp} />
          <span>{parseInt(item.likes) || 0}</span>
        </>
      ));
      body.appendChild(like);
      min.appendChild(node);
    }
    lists.current.parentElement.scrollTop = scrollTop.current;
    onScroll();
  }, [col, data]);
  React.useEffect(() => {
    let onResize = debounce(() => setCol(calcCols), 600);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return (
    <>
      <Helmet>
        <title>Linky</title>
      </Helmet>
      <Nav />
      <div className="list-container" onScroll={onScroll}>
        <MDBContainer>
          <MDBRow className={"note-list cols-" + col} ref={lists}>
            {'0'.repeat(col).split('').map((v, index) => (
              <MDBCol className="note-col" key={'col-' + index} ref={e => cols.push(e)} />
            ))}
          </MDBRow>
        </MDBContainer>
      </div>
      <LightBox ref={lightbox} />
      <Loading ref={loading} />
    </>
  );
}
